import React, { useState } from 'react';
import { post } from '../../Auths/AuthToken';
import setUiMessage from '../../../Utilities/Tostify';
import Select from 'react-select';
import { useSelector } from 'react-redux';
import Button from '../../Button';

const buildOptions = (arr, labelKey) =>
  (arr || []).map((item) => ({ value: item?.id, label: item?.[labelKey] }));

const getSelectedOption = (options, value) =>
  (options || []).find((o) => String(o.value) === String(value)) || null;

function Statistics({ data, patientId, reload }) {
  const { user } = useSelector((state) => state.auth);
  const [isEdit, setIsEdit] = useState(false);
  const [allDataEdit, setAllDataEdit] = useState(null);
  const [formValues, setFormValues] = useState({
    bloodGroup: '',
    ethincity: '',
    ethincityGroup: ' ',
    familySize: '',
    interpreterReq: '',
    martialStatus: '',
    placeOfBirth: '',
    preferredLanguage: '',
    race: '',
    raceGroup: '',
    referralName: '',
    referralSource: '',
    religion: '',
    yearlyIncome: '',
  });

  const handleIdentityChange = async () => {
    setIsEdit(true);
    try {
      const response = await post('api/patient/Patient/editPatientProfile', {
        patientId: patientId,
      });
      if (response?.status === 200) {
        setAllDataEdit(response?.data);
        const patientDetails = response?.data?.patientDetail;
        setFormValues((ele) => {
          return {
            ...ele,
            bloodGroup: patientDetails?.bloodGroupId,
            ethincity:
              patientDetails?.stats_ethincity &&
              allDataEdit?.statisticsDetailArr?.dropDownEthnicity
                ?.filter((o) =>
                  patientDetails?.stats_ethincity.split(',')?.includes(o.id)
                )
                .map((i) => ({ value: i?.id, label: i?.title })),
            ethincityGroup:
              patientDetails?.stats_ethincity_group &&
              allDataEdit?.statisticsDetailArr?.dropDownEthnicityGroup
                ?.filter((o) =>
                  patientDetails?.stats_ethincity_group
                    .split(',')
                    ?.includes(o.id)
                )
                .map((i) => ({ value: i?.id, label: i?.title })),
            familySize: patientDetails?.stats_family_size,
            interpreterReq: patientDetails?.interpreter_required,
            martialStatus: patientDetails?.marital_status,
            placeOfBirth: patientDetails?.stats_place_birth,
            preferredLanguage: patientDetails?.stats_language,
            race:
              patientDetails?.stats_race &&
              allDataEdit?.statisticsDetailArr?.dropDownRace
                ?.filter((o) =>
                  patientDetails?.stats_race.split(',')?.includes(o.id)
                )
                .map((i) => ({ value: i?.id, label: i?.title })),
            raceGroup:
              patientDetails?.stats_race_group &&
              allDataEdit?.statisticsDetailArr?.dropDownRaceGroup
                ?.filter((o) =>
                  patientDetails?.stats_race_group.split(',')?.includes(o.id)
                )
                .reverse()
                .map((i) => ({ value: i?.id, label: i?.title })),
            referralName: patientDetails?.referral_source_name,
            referralSource: patientDetails?.stats_referral_source,
            religion: patientDetails?.patient_religion,
            yearlyIncome: patientDetails?.stats_yearly_income,
          };
        });
      }
    } catch (e) {
      setUiMessage('err', e.message);
    }
  };

  const handleFieldChange = ({ target: { id, value } }) => {
    setFormValues((ele) => {
      return { ...ele, [id]: value };
    });
  };

  const handleSelectChange = (id, option) => {
    setFormValues((ele) => {
      return { ...ele, [id]: option ? option.value : '' };
    });
  };

  const handleMultiSelect = (e, type) => {
    setFormValues((ele) => {
      if (type === 'race') return { ...ele, race: e };
      if (type === 'racegrp') return { ...ele, raceGroup: e };
      if (type === 'ethincity') return { ...ele, ethincity: e };
      if (type === 'ethincitygrp') return { ...ele, ethincityGroup: e };
    });
  };

  const handleSave = async () => {
    setIsEdit(false);
    try {
      const response = await post('api/patient/Patient/updatePatient', {
        updateInfo: 'Statistics-Information',
        flag: '1',
        patient_id: patientId,
        stats_language: formValues?.preferredLanguage,
        interpreter_required: formValues?.interpreterReq,
        stats_race:
          formValues?.race &&
          formValues?.race.length > 0 &&
          formValues?.race.map((i) => i?.value).join(','),
        stats_race_group:
          formValues?.raceGroup &&
          formValues?.raceGroup.length > 0 &&
          formValues?.raceGroup.map((i) => i?.value).join(','),
        stats_ethincity:
          formValues?.ethincity &&
          formValues?.ethincity.length > 0 &&
          formValues?.ethincity.map((i) => i?.value).join(','),
        stats_ethincity_group:
          formValues?.ethincityGroup &&
          formValues?.ethincityGroup.length > 0 &&
          formValues?.ethincityGroup.map((i) => i?.value).join(','),
        patient_religion: formValues?.religion,
        blood_type: formValues?.bloodGroup,
        stats_place_birth: formValues?.placeOfBirth,
        marital_status: formValues?.martialStatus,
        stats_family_size: formValues?.familySize,
        stats_yearly_income: formValues?.yearlyIncome,
        stats_referral_source: formValues?.referralSource,
        referral_source_name: formValues?.referralName,
        loginUserId: user?.id,
      });
      if (response?.status === 200) {
        reload();
      }
    } catch (e) {
      setUiMessage('err', e.message);
    }
  };
  return (
    <>
      {isEdit ? (
        <div className="demo-main-con-sec">
          <div className="demo-main-con-chld-hdr">
            <div className="chld-hdr-hdng">Statistics:</div>
            <div
              className="chld-hdr-edt"
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                justifyContent: 'flex-end',
              }}
            >
              <Button
                variant="default"
                onClick={() => setIsEdit(false)}
                style={{ fontSize: '13px', padding: '3px 12px' }}
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                onClick={handleSave}
                style={{ fontSize: '13px', padding: '3px 12px' }}
              >
                Save
              </Button>
            </div>
          </div>
          <div className="demo-main-con-chld-bdy">
            <div className="flex-sec alt-rw">
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Place of Birth:</span>
                <span className="nsu-act-val">
                  <input
                    type="text"
                    className="inpt-width-nw"
                    placeholder=""
                    id="placeOfBirth"
                    value={formValues.placeOfBirth || ''}
                    onChange={handleFieldChange}
                  />
                </span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Preferred Language:</span>
                <span className="nsu-act-val">
                  {(() => {
                    const preferredLanguageOptions = buildOptions(
                      allDataEdit?.statisticsDetailArr?.prefLan,
                      'lang_name'
                    );
                    return (
                      <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        isClearable
                        placeholder="Select"
                        value={getSelectedOption(
                          preferredLanguageOptions,
                          formValues.preferredLanguage
                        )}
                        options={preferredLanguageOptions}
                        onChange={(opt) =>
                          handleSelectChange('preferredLanguage', opt)
                        }
                      />
                    );
                  })()}
                </span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Marital Status:</span>
                <span className="nsu-act-val">
                  {(() => {
                    const martialStatusOptions = buildOptions(
                      allDataEdit?.statisticsDetailArr?.martialStatus,
                      'title'
                    );
                    return (
                      <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        isClearable
                        placeholder="Select"
                        value={getSelectedOption(
                          martialStatusOptions,
                          formValues.martialStatus
                        )}
                        options={martialStatusOptions}
                        onChange={(opt) =>
                          handleSelectChange('martialStatus', opt)
                        }
                      />
                    );
                  })()}
                </span>
              </div>
            </div>
            <div className="flex-sec">
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Race:</span>
                <span className="nsu-act-val">
                  <Select
                    value={formValues.race || ''}
                    options={
                      allDataEdit?.statisticsDetailArr?.dropDownRace &&
                      allDataEdit?.statisticsDetailArr?.dropDownRace.map(
                        (item) => ({ value: item?.id, label: item?.title })
                      )
                    }
                    isMulti
                    onChange={(e) => handleMultiSelect(e, 'race')}
                  />
                </span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Interpreter Required :</span>
                <span className="nsu-act-val">
                  <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    isClearable
                    placeholder="Select"
                    value={getSelectedOption(
                      [
                        { value: '1', label: 'Yes' },
                        { value: '0', label: 'No' },
                      ],
                      formValues.interpreterReq
                    )}
                    options={[
                      { value: '1', label: 'Yes' },
                      { value: '0', label: 'No' },
                    ]}
                    onChange={(opt) =>
                      handleSelectChange('interpreterReq', opt)
                    }
                  />
                </span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Family Size:</span>
                <span className="nsu-act-val">
                  <input
                    type="text"
                    className="inpt-width-nw"
                    placeholder=""
                    id="familySize"
                    value={formValues.familySize || ''}
                    onChange={handleFieldChange}
                  />
                </span>
              </div>
            </div>
            <div className="flex-sec alt-rw">
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Race Group:</span>
                <span className="nsu-act-val">
                  <Select
                    value={formValues.raceGroup || ''}
                    options={
                      allDataEdit?.statisticsDetailArr?.dropDownRaceGroup &&
                      allDataEdit?.statisticsDetailArr?.dropDownRaceGroup.map(
                        (item) => ({ value: item?.id, label: item?.title })
                      )
                    }
                    isMulti
                    onChange={(e) => handleMultiSelect(e, 'racegrp')}
                  />
                </span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Religion:</span>
                <span className="nsu-act-val">
                  {(() => {
                    const religionOptions = buildOptions(
                      allDataEdit?.statisticsDetailArr?.dropDownReligion,
                      'title'
                    );
                    return (
                      <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        isClearable
                        placeholder="Select"
                        value={getSelectedOption(
                          religionOptions,
                          formValues.religion
                        )}
                        options={religionOptions}
                        onChange={(opt) =>
                          handleSelectChange('religion', opt)
                        }
                      />
                    );
                  })()}
                </span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Yearly Income:</span>
                <span className="nsu-act-val">
                  {(() => {
                    const yearlyIncomeOptions = buildOptions(
                      allDataEdit?.statisticsDetailArr?.yearlyIncome,
                      'title'
                    );
                    return (
                      <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        isClearable
                        placeholder="Select"
                        value={getSelectedOption(
                          yearlyIncomeOptions,
                          formValues.yearlyIncome
                        )}
                        options={yearlyIncomeOptions}
                        onChange={(opt) =>
                          handleSelectChange('yearlyIncome', opt)
                        }
                      />
                    );
                  })()}
                </span>
              </div>
            </div>

            <div className="flex-sec">
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Ethnicity:</span>
                <span className="nsu-act-val">
                  {/* <select
                    className="inpt-width-nw"
                    id="ethincity"
                    value={formValues.ethincity}
                    onChange={handleFieldChange}
                  >
                    <option value="">Select</option>
                    {allDataEdit?.statisticsDetailArr?.dropDownEthnicity &&
                      allDataEdit?.statisticsDetailArr?.dropDownEthnicity.map(
                        (item, i) => {
                          return (
                            <option key={i} value={item?.id}>
                              {item?.title}
                            </option>
                          );
                        }
                      )}
                  </select> */}
                  <Select
                    value={formValues.ethincity || ''}
                    options={
                      allDataEdit?.statisticsDetailArr?.dropDownEthnicity &&
                      allDataEdit?.statisticsDetailArr?.dropDownEthnicity.map(
                        (item) => ({ value: item?.id, label: item?.title })
                      )
                    }
                    isMulti
                    onChange={(e) => handleMultiSelect(e, 'ethincity')}
                  />
                </span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Blood Group:</span>
                <span className="nsu-act-val">
                  {(() => {
                    const bloodGroupOptions = buildOptions(
                      allDataEdit?.statisticsDetailArr?.bloodGroup,
                      'val'
                    );
                    return (
                      <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        isClearable
                        placeholder="Select"
                        value={getSelectedOption(
                          bloodGroupOptions,
                          formValues.bloodGroup
                        )}
                        options={bloodGroupOptions}
                        onChange={(opt) =>
                          handleSelectChange('bloodGroup', opt)
                        }
                      />
                    );
                  })()}
                </span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Referral Source:</span>
                <span className="nsu-act-val">
                  {(() => {
                    const referralSourceOptions = buildOptions(
                      allDataEdit?.statisticsDetailArr?.referralSource,
                      'title'
                    );
                    return (
                      <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        isClearable
                        placeholder="Select"
                        value={getSelectedOption(
                          referralSourceOptions,
                          formValues.referralSource
                        )}
                        options={referralSourceOptions}
                        onChange={(opt) =>
                          handleSelectChange('referralSource', opt)
                        }
                      />
                    );
                  })()}
                </span>
              </div>
            </div>

            <div className="flex-sec alt-rw">
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Ethnicity Group:</span>
                <span className="nsu-act-val">
                  <Select
                    value={formValues.ethincityGroup || ''}
                    options={
                      allDataEdit?.statisticsDetailArr
                        ?.dropDownEthnicityGroup &&
                      allDataEdit?.statisticsDetailArr?.dropDownEthnicityGroup.map(
                        (item) => ({ value: item?.id, label: item?.title })
                      )
                    }
                    isMulti
                    onChange={(e) => handleMultiSelect(e, 'ethincitygrp')}
                  />
                </span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">&nbsp;</span>
                <span className="nsu-act-val">&nbsp;</span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Referral Name:</span>
                <span className="nsu-act-val">
                  <input
                    type="text"
                    className="inpt-width-nw"
                    placeholder=""
                    id="referralName"
                    value={formValues.referralName || ''}
                    onChange={handleFieldChange}
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="demo-main-con-sec">
          <div className="demo-main-con-chld-hdr">
            <div className="chld-hdr-hdng">Statistics:</div>
            <div className="chld-hdr-edt">
              <span className="demo-edt-icn" onClick={handleIdentityChange}>
                &#9998;
              </span>
            </div>
          </div>
          <div className="demo-main-con-chld-bdy">
            <div className="flex-sec alt-rw">
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Place of Birth:</span>
                <span className="nsu-act-val">{data?.placeOfBirth}</span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Preferred Language:</span>
                <span className="nsu-act-val">{data?.preferredLanguage}</span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Marital Status:</span>
                <span className="nsu-act-val">{data?.martialStatus}</span>
              </div>
            </div>
            <div className="flex-sec">
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Race:</span>
                <span className="nsu-act-val">{data?.race}</span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Interpreter Required :</span>
                <span className="nsu-act-val">{data?.interpreterReq}</span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Family Size:</span>
                <span className="nsu-act-val">{data?.familySize}</span>
              </div>
            </div>
            <div className="flex-sec alt-rw">
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Race Group:</span>
                <span className="nsu-act-val">{data?.raceGroup}</span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Religion:</span>
                <span className="nsu-act-val">{data?.religion}</span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Yearly Income:</span>
                <span className="nsu-act-val">{data?.yearlyIncome}</span>
              </div>
            </div>

            <div className="flex-sec">
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Ethnicity:</span>
                <span className="nsu-act-val">{data?.ethincity}</span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Blood Group:</span>
                <span className="nsu-act-val">{data?.bloodGroup}</span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Referral Source:</span>
                <span className="nsu-act-val">{data?.referralSource}</span>
              </div>
            </div>

            <div className="flex-sec alt-rw">
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Ethnicity Group:</span>
                <span className="nsu-act-val">{data?.ethincityGroup}</span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">&nbsp;</span>
                <span className="nsu-act-val">&nbsp;</span>
              </div>
              <div className="demo-main-con-chld-bdy-rw">
                <span className="nsu-act-lbl">Referral Name:</span>
                <span className="nsu-act-val">{data?.referralName}</span>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Statistics;
